export default "__VITE_ASSET__CMz_aF4h__"